import styled from "styled-components";

export const SSettingsTopNavTitle = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  font-size: 14px;

  > div {
    font-size: 12px;
  }
`;
